<template>
  <el-dialog :title="'【' + modelParam.task_id + '】' + modelParam.describe" center class="devOps-modelFour"
    :visible.sync="dialogVisible" width="80%" top="10px" :before-close="handleClose" :close-on-click-modal="false">
    <el-form size="mini" ref="form" :rules="rules" :model="form" label-width="100px">
      <el-form-item label="测试人员" prop="tester">
        <el-select style="width: 100%" v-model="form.tester" @change="testerChange" multiple filterable default-first-option
          placeholder="请输入测试人员邮箱前缀，多人以逗号分隔">
          <el-option v-for="item in users" :key="item[1]" :label="item[0]" :value="item[1]">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button :disabled="runLoading" type="warning" @click="onSubmit('run')">提测<i v-show="runLoading"
            class="el-icon-loading"></i></el-button>
        <el-button :disabled="skipLoading" type="warning" @click="onSubmit('skip')">跳过<i v-show="skipLoading"
            class="el-icon-loading"></i></el-button>
        <el-button type="info" @click="queryDevOpsSpaceListStageOutputApi">查看历史</el-button>
        <el-button type="warning" @click="handleClose">返回</el-button>
      </el-form-item>
    </el-form>
    <div v-if="msgNum">
      总计{{ msgNum }}个提测人员，成功{{ msgSuccessNum }}个,失败{{
          msgNum - msgSuccessNum
      }}个
    </div>
    <pre v-if="message" v-html="message" class="tips-message"></pre>
    <TableOne v-if="tableData.length" :tableData="tableData" />
  </el-dialog>
</template>
<script>
import {
  getDevOpsSpaceListStageParmApi,
  postDevopsSpaceStageActionApi,
  getDevOpsSpaceListStageOutputApi,
  getDevOpsSpaceStageSelectmapApi,
} from "@/server/tops/devOps";
import { TableOne } from "../table/index";
export default {
  components: { TableOne },
  props: {
    dialogVisible: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    hideDialogVisible: {
      type: Function,
      default: () => {
        return function () { };
      },
    },
    modelParam: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      form: {},
      rules: {
        tester: [
          { required: true, message: "请输入测试人员", trigger: "blur" },
        ],
      },
      message: "",
      runLoading: false,
      skipLoading: false,
      msgSuccessNum: 0,
      msgNum: 0,
      tableData: [],
      users: [],
    };
  },
  created() {
    const { tester_user = '' } = this.modelParam;
    this.form.tester = tester_user.split(',');
  },
  async mounted() {
    await this.queryDevOpsSpaceStageSelectmapApi();
    // await this.queryDevOpsSpaceListStageParmInfo();
  },
  methods: {
    // modules select获取
    async queryDevOpsSpaceStageSelectmapApi() {
      try {
        const ret = await getDevOpsSpaceStageSelectmapApi();
        this.users = ret["devops-tasklist-users"].map((item) => {
          item[0] = `${item[0]}（${item[1]}）`;
          return item;
        });
      } catch (error) {
        this.$notify({
          message: error || "获取select失败",
          type: "error",
        });
      }
    },
    // 获取任务阶段设置信息
    // async queryDevOpsSpaceListStageParmInfo() {
    //   const { stage_id, task_id } = this.modelParam;
    //   try {
    //     const ret = await getDevOpsSpaceListStageParmApi({
    //       stage_id,
    //       task_id,
    //     });
    //     if (ret.status === "success") {
    //       this.form = {
    //         ...ret.data,
    //         tester: ret.data.tester ? ret.data.tester.split(",") : [],
    //       };
    //     } else {
    //       this.$notify({
    //         message: ret.error || "获取失败",
    //         type: "error",
    //       });
    //     }
    //   } catch (error) {
    //     this.$notify({
    //       message: error || "获取失败",
    //       type: "error",
    //     });
    //   }
    // },
    // 获取历史执行信息
    async queryDevOpsSpaceListStageOutputApi() {
      const { stage_id = "", task_id = "" } = this.modelParam;
      try {
        const ret = await getDevOpsSpaceListStageOutputApi({
          stage_id,
          task_id,
        });
        if (ret.status === "success") {
          let instance = JSON.parse(ret.data) || [];
          instance.map((item) => {
            return (item.content = JSON.stringify(item.output, null, 2));
          });
          console.log(instance);
          this.message = instance.length ? "" : "暂无历史记录";
          this.tableData = instance;
        }
      } catch (error) {
        this.$notify({
          message: error || "获取失败",
          type: "error",
        });
      }
    },
    testerChange(val){
      this.form.tester = val;
      this.$nextTick(()=>{
        this.$forceUpdate()
      })
    },
    // 关闭按钮
    handleClose() {
      this.hideDialogVisible("dialogVisible" + this.modelParam.stage);
    },
    // 提交
    async onSubmit(action) {
      this.message = "";
      this.msgSuccessNum = this.msgNum = 0;
      this.tableData = [];
      action === "run" && (await this.queryActionRunSubmit("run"));
      action === "skip" && (await this.queryActionSkipSubmit("skip"));
    },
    // 执行接口调用
    async queryActionRunSubmit(action) {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          const {
            stage_id = "",
            task_id = "",
            stage_name = "",
          } = this.modelParam;
          const { tester = [] } = this.form;
          const param = {
            action,
            stage_id,
            task_id,
            stage_name,
            tester: tester.toString(),
          };
          this.runLoading = true;
          try {
            const ret = await postDevopsSpaceStageActionApi(param);
            this.message = JSON.stringify(ret.data || "", null, 2);
            ret.data?.output?.msg.forEach((item) => {
              this.msgNum++;
              if (item.code === 0) {
                this.msgSuccessNum++;
              }
            });
            this.$notify({
              message: "提交成功",
              type: "success",
            });
          } catch (error) {
            this.$notify({
              message: error || "操作失败",
              type: "error",
            });
          } finally {
            this.runLoading = false;
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 跳过接口调用
    async queryActionSkipSubmit(action) {
      const { stage_id = "", task_id = "", stage_name = "" } = this.modelParam;
      const param = {
        action,
        stage_id,
        task_id,
        stage_name,
        tester: "",
      };
      try {
        this.skipLoading = true;
        const ret = await postDevopsSpaceStageActionApi(param);
        this.$notify({
          message: ret.status === "success" ? "跳过成功" : "跳过失败",
          type: ret.status === "success" ? "success" : "error",
        });
        ret.status === "success"
          ? this.hideDialogVisible("dialogVisible" + this.modelParam.stage)
          : (this.message = JSON.stringify(ret.data || "", null, 2));
      } catch (error) {
        this.$notify({
          message: error || "操作失败",
          type: "error",
        });
      } finally {
        this.skipLoading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.tips-message {
  max-height: 240px;
  overflow-y: scroll;
  white-space: pre-wrap;
  background: #f1fbec;
}
</style>
<style lang="scss">
.devOps-modelFour {
  .el-input__inner {
    font-size: 14px !important;
  }

  .el-button--mini {
    padding: 12px 20px;
    font-size: 14px;
  }

  .el-dialog__header {
    border-bottom: 1px solid #efefef;
    font-weight: bold;
    padding: 20px 40px 10px;
  }

  .el-dialog__title,
  .el-form-item__label,
  .el-button {
    font-weight: bold;
  }

  .el-button {
    margin-right: 15px;
    letter-spacing: 2px;
    position: relative;

    .el-icon-loading {
      position: absolute;
      right: 5px;
    }
  }
}
</style>